export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/imageCompressWebpackWorker.22d53f43.worker.js");
}
